import React, { Component } from "react";
import "./ViewSignatureSamplePopupDynamic.scss";
import rightSignatureSample from "../../../assets/right-signature-sample.jpg";
import wrongSignatureOne from "../../../assets/wrong-signature-one.jpg";
import wrongSignatureTwo from "../../../assets/wrong-signature-two-new.jpg";
import wrongSignatureThree from "../../../assets/wrong-signature-three.jpg";

import BottomPanel from "../../BottomPanel/BottomPanel";
export interface IViewSignatureSamplePopupProps {
  setShowPopup: Function;
  showPopup: boolean;
  position: any;
  parentClassName?: string;
}

const ViewSignatureSamplePopupDynamic = (props: IViewSignatureSamplePopupProps) => {
  const popupRefone = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (popupRefone.current !== null && popupRefone.current !== undefined) {
        props?.setShowPopup();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);
  return (
    <div
      className={`overlay-other ${props.parentClassName ?? ""}`}
      style={{
        position: "absolute",
        top: props.position.top,
        left: `${props.position.left}rem`,
        zIndex: 1000,
      }}
      ref={popupRefone}
    >

      <div className="popup-other">
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={(e) => {
            if (props?.setShowPopup !== undefined) props?.setShowPopup(false);
          }}
        >
          <i className="edel-icon-close" />
        </button>

        <h2 className="popup-title">Guide for Signature Upload</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}
        <div className="grid">
          <div className="box">
            <img
              src={rightSignatureSample}
              alt="Valid Signature"
              height={80}
              width={120}
            />
            <p className="success">Use a clear background.</p>
          </div>

          <div className="box">
            <img
              src={wrongSignatureOne}
              alt="Ruled Background"
              height={80}
              width={120}
            />
            <p className="error"> Don't use a ruled background.</p>
          </div>

          <div className="box">
            <img
              src={wrongSignatureTwo}
              alt="Ruled Background"
              height={80}
              width={120}
            />
            <p className="error"> Don't use a light stroke.</p>
          </div>

          <div className="box">
            <img
              src={wrongSignatureThree}
              alt="Thick Stroke"
              height={80}
              width={120}
            />
            <p className="error"> Don't use a thick stroke.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewSignatureSamplePopupDynamic;
